import {
  PRODUCT_EMAIL_RECEIVE,
  PRODUCT_EMAIL_ERROR,
  ADVERTISE_EMAIL_RECEIVE,
  MAIL_LOADING,
} from '../constants';

const defaultState = {
  isSuccessful: false,
  haveResponded: false,
  isLoading: false,
  error: '',
};

export const mailProduct = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADVERTISE_EMAIL_RECEIVE:
      return {
        ...state,
        ...{
          isSuccessful: payload.success,
          haveResponded: true,
          isLoading: false,
        },
      };
    case PRODUCT_EMAIL_RECEIVE:
      return {
        ...state,
        ...{
          isSuccessful: payload.success,
          haveResponded: true,
          isLoading: false,
        },
      };
    case PRODUCT_EMAIL_ERROR:
      return {
        ...state,
        ...{
          isSuccessful: false,
          haveResponded: true,
          isLoading: false,
          message: payload.error,
        },
      };
    case MAIL_LOADING:
      return {
        ...state,
        ...{
          isSuccessful: state.isSuccessful,
          haveResponded: false,
          isLoading: payload.isLoading,
        },
      };
    default:
      return state;
  }
};
